<template>
  <el-tag v-if="state && stateLabel" size="medium" :type="cssClass"
    >{{ stateLabel }}
  </el-tag>
</template>

<script>
import constants from "../../../constants";
import hanhChinhUtils from "../../../services/hanhChinhUtils";

export default {
  name: "hc-command-state",
  props: ["state"],

  computed: {
    stateLabel() {
      return hanhChinhUtils.getHcCommandStateName(this.state);
    },

    cssClass() {
      switch (this.state) {
        case constants.HC_STATE.STATE_CODE.CHI_DAO.DANG_THUC_HIEN:
          return "warning";
        case constants.HC_STATE.STATE_CODE.CHI_DAO.CHO_PHE_DUYET_HOAN_THANH:
          return "";
        case constants.HC_STATE.STATE_CODE.CHI_DAO.HOAN_THANH:
          return "success";
        case constants.HC_STATE.STATE_CODE.CHI_DAO.HUY_CHI_DAO:
          return "danger";
        default:
          return "";
      }
    }
  },

  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-command-state.vue